import axios from '@/libs/api.request';
export var getTableData = function getTableData() {
  return axios.request({
    url: 'get_table_data',
    method: 'get'
  });
};
export var getDragList = function getDragList() {
  return axios.request({
    url: 'get_drag_list',
    method: 'get'
  });
};
export var errorReq = function errorReq() {
  return axios.request({
    url: 'error_url',
    method: 'post'
  });
};
export var saveErrorLogger = function saveErrorLogger(info) {
  return axios.request({
    url: 'save_error_logger',
    data: info,
    method: 'post'
  });
};
export var uploadImg = function uploadImg(formData) {
  return axios.request({
    url: 'image/upload',
    data: formData
  });
};